module.exports = __webpack_public_path__ + "img/imagen-inscripcion.a81e2a8a.jpg";